import { Form, Input, Button, Alert, Row, Col, Card } from "antd";
import React, { useContext, useEffect, useState } from "react";
import { HeartOutlined } from "@ant-design/icons";
import { SignedInDoctor } from "../auth/interfaces";
import { SignedInContext } from "../AppEnv";
import "./PriceTut.css";
import PriceBusiness from "./PriceBussiness";
import PriceProfessional from "./PriceProfessional";
import PriceExclusive from "./PriceExclusive";
import { useLocation, useSearchParams } from "react-router-dom";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const PriceInfo = () => {
  const [width, setWidth] = useState(0);
  const handleResize = () => setWidth(window.innerWidth);

  const [searchParams, setSearchParams] = useSearchParams();
  const removeParam = (key: string) => {
    searchParams.delete(key);
    setSearchParams(searchParams);
  };

  const query = useQuery();
  const orderSuccess = query.get("orderSuccess"); // example.com?param1=value1

  useEffect(() => {
    if (orderSuccess != null) {
      if (orderSuccess === "1") alert("Ordine effettuato con successo");
      else alert("Ordine cancellato");
      removeParam("orderSuccess");
    }

    //mount
    window.addEventListener("resize", handleResize);
    setWidth(window.innerWidth);
    //unmount
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
      {width > 768 && (
        //Desktop
        <>
          <div className="incenter">
            <PriceBusiness />

            <PriceProfessional />
            <PriceExclusive />
          </div>
        </>
      )}
      {width <= 768 && (
        //Mobile
        <>
          <Row>
            <Col span={24}>
              <PriceBusiness />
            </Col>
            <Col span={24}>
              <PriceProfessional />
            </Col>
            <Col span={24}>
              <PriceExclusive />
            </Col>
          </Row>
        </>
      )}
    </>
  );
};

export default PriceInfo;
